var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filters"},[_c('FiltersHeader'),(this.selectedFilterSection === '')?_c('FiltersMenu'):_vm._e(),(_vm.showSection('club'))?_c('ClubFilter'):_vm._e(),(_vm.showSection('trainer'))?_c('TrainerFilter'):_vm._e(),(_vm.showSection('training'))?_c('TrainingFilter'):_vm._e(),(_vm.showSection('place'))?_c('PlaceFilter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }